import React from "react"
import "./style.scss"

const Paragraphs = ({ paras }) => {
  return (
    <div className="content">
      {paras &&
        paras.map((para, idx) => (
          <div key={idx} className="content-item">
            <h1 className="header">{para.title}</h1>
            <p className="text">{para.content}</p>
            {para.unorderedList &&
              para.unorderedList.map(item => (
                <ul className="unorderedList">
                  <li>
                    <p className="text">{item}</p>
                  </li>
                </ul>
              ))}
          </div>
        ))}
    </div>
  )
}

const ListIems = ({ points }) => {
  return (
    <div className="content">
      {points &&
        points.map((point, idx) => (
          <div key={idx} className="content-item">
            <h1 className="header">{point.title}</h1>
            <h2 className="subHeader">{point.subTitle}</h2>
            {point.unorderedList &&
              point.unorderedList.map(item => (
                <ul>
                  <li className="listItems">
                    <p className="text">{item}</p>
                  </li>
                </ul>
              ))}
          </div>
        ))}
    </div>
  )
}

const WriteForUs = ({ sectionData }) => {
  const {
    title,
    description,
    image,
    contents,
    points,
    conclusion,
  } = sectionData
  return (
    <div className="write-for-us">
      <div className="top__area">
        <div>
          <h1>{title}</h1>
        </div>
        <div>
          <img src={image} alt="article" />
        </div>
      </div>
      <div className="content">
        <div className="content-item">
          <p className="text">{description}</p>
        </div>
      </div>
      <Paragraphs paras={contents} />
      <ListIems points={points} />
      <Paragraphs paras={conclusion} />
    </div>
  )
}

export default WriteForUs
